import { User, Group } from "./api/groupUser.api";

// Generate mock users
const generateUsers = (count: number): User[] => {
  const users: User[] = [];
  const firstNames = ["John", "Jane", "Alice", "Bob", "Charlie", "Diana", "Emma", "Frank", "Grace", "Henry", "Ivy", "Jack", "Kate", "Liam", "Mia", "Noah", "Olivia", "Peter", "Quinn", "Ryan"];
  const lastNames = ["Smith", "Johnson", "Williams", "Brown", "Jones", "Garcia", "Miller", "Davis", "Rodriguez", "Martinez", "Hernandez", "Lopez", "Gonzalez", "Wilson", "Anderson", "Thomas", "Taylor", "Moore", "Jackson", "Martin"];
  
  for (let i = 0; i < count; i++) {
    const firstName = firstNames[i % firstNames.length];
    const lastName = lastNames[Math.floor(i / firstNames.length) % lastNames.length];
    users.push({
      id: `user-${i + 1}`,
      name: `${firstName} ${lastName}`,
      email: `${firstName.toLowerCase()}.${lastName.toLowerCase()}${i > 19 ? i : ''}@company.com`,
      avatar: `https://i.pravatar.cc/150?img=${(i % 70) + 1}`,
    });
  }
  
  return users;
};

export const mockUsers: User[] = generateUsers(50);

// Generate mock groups
export const mockGroups: Group[] = [
  {
    id: "group-1",
    
    name: "Engineering Team",
    members: mockUsers.slice(0, 15),
  },
  {
    id: "group-2",
    name: "Design Team",
    members: mockUsers.slice(10, 22),
  },
  {
    id: "group-3",
    name: "Product Team",
    members: mockUsers.slice(15, 28),
  },
  {
    id: "group-4",
    name: "Marketing Team",
    members: mockUsers.slice(20, 35),
  },
  {
    id: "group-5",
    name: "Sales Team",
    members: mockUsers.slice(25, 40),
  },
  {
    id: "group-6",
    name: "HR Team",
    members: mockUsers.slice(30, 38),
  },
  {
    id: "group-7",
    name: "Finance Team",
    members: mockUsers.slice(35, 45),
  },
  {
    id: "group-8",
    name: "Operations Team",
    members: mockUsers.slice(40, 50),
  },
];
